import React from 'react'
import { Card, CardActionArea, CardContent, Typography } from '@mui/material'
import { Link } from 'react-router-dom'

interface ResearchTopicCardProps {
  title: string
  description: string
  href: string
}

const ResearchTopicCard: React.FC<ResearchTopicCardProps> = ({
  title,
  description,
  href,
}) => {
  return (
    <Card variant="outlined" sx={{ height: '100%' }}>
      <CardActionArea
        component={Link}
        to={href}
        sx={{ height: '100%', display: 'flex', alignItems: 'flex-start' }}
      >
        <CardContent>
          <Typography
            variant="h6"
            sx={{ fontWeight: 600, mb: 1, color: 'primary.main' }}
          >
            {title}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {description}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  )
}

export default ResearchTopicCard
